import React from "react";
import "./banner.scss";

const banner = () => {
  return <div className="container-background"></div>;
};

export default banner;
